import type { App as VueApp } from "vue";
import type { Router } from "vue-router";
import VueMatomo from "@et/vue-matomo";

import Config from "@/common/config";

export function setupMatomo(app: VueApp, router: Router): void {
  const { matomoConfig } = Config;

  if (!matomoConfig.enabled) {
    return;
  }

  app.use(VueMatomo, {
    host: matomoConfig.host,
    siteId: matomoConfig.siteID,
    trackerFileName: matomoConfig.trackerFileName,
    router,
    enableHeartBeatTimer: matomoConfig.enableHeartBeatTimer,
    heartBeatTimerInterval: matomoConfig.heartBeatTimerInterval,
    debug: matomoConfig.debug,
  });
}
